module.exports = __webpack_public_path__ + "img/icon_onboarding_bank.2aea6d07.svg";